module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "how"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("How to Use This Book")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is organized as a day minder, a journal packed with a year’s worth of ways to care for, understand, socialize, and honor your cat. Each unique entry will inspire, inform, and entertain. Every week contains six entries designed to feed your cat-loving soul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is more than one way to read this book. You can dive in and read from beginning to end, cozying up to it as you would a page-turner novel. (For cat lovers, there’s no such thing as overdosing on cat information.) Or you can read an entry each day—it will last all year that way. You can crack the book open in the middle and read to the back, then backward to the front. Go ahead and read the last page first. That’s not cheating. This book is yours to enjoy in your own way, at your own pace. Dog-ear the pages (no pun intended) so you can revisit your favorite entries time and again. Read out loud to your cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each day is a surprise. You’ll discover detailed cat health information, amusing trivia, and creative projects to make for your cat (and yourself). On every page, we explore the spirit and love between a cat and her human. This book is one more way to deepen the relationship.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36417de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/how.vue
// module id = 69
// module chunks = 0